export function mapIdsToNames<K>(
  list: K[] | undefined,
  listOfAllItems: [string | number, string][]
) {
  return list?.map(
    (id) => listOfAllItems.find((b) => String(b[0]) === String(id))?.[1] ?? id
  );
}
